import styledError from '../utils/error';
var MAX_SMI = 1 << (31 - 1);
var groupIDRegister = new Map();
var reverseRegister = new Map();
var nextFreeGroup = 1;
export var resetGroupIds = function () {
    groupIDRegister = new Map();
    reverseRegister = new Map();
    nextFreeGroup = 1;
};
export var getGroupForId = function (id) {
    if (groupIDRegister.has(id)) {
        return groupIDRegister.get(id);
    }
    while (reverseRegister.has(nextFreeGroup)) {
        nextFreeGroup++;
    }
    var group = nextFreeGroup++;
    if (process.env.NODE_ENV !== 'production' && ((group | 0) < 0 || group > MAX_SMI)) {
        throw styledError(16, "".concat(group));
    }
    groupIDRegister.set(id, group);
    reverseRegister.set(group, id);
    return group;
};
export var getIdForGroup = function (group) {
    return reverseRegister.get(group);
};
export var setGroupForId = function (id, group) {
    groupIDRegister.set(id, group);
    reverseRegister.set(group, id);
};
//# sourceMappingURL=GroupIDAllocator.js.map